"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BathIconSmall = BathIconSmall;
exports.default = BathIcon;
var _react = _interopRequireDefault(require("react"));
var _iconBase = _interopRequireDefault(require("./shared/icon-base"));
var _core = require("@emotion/core");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function BathIcon(props) {
  return (0, _core.jsx)(_iconBase.default, props, (0, _core.jsx)("path", {
    d: "M16.8481 8C17.2513 8.56671 17.4937 9.25415 17.498 10H20.5454C20.4912 10.1431 20.4473 10.2915 20.415 10.4443L19.208 17.1733C19.1074 17.6523 18.6182 18 18.0444 18H5.95557C5.38184 18 4.89258 17.6523 4.79786 17.2022L3.57911 10.415C3.54932 10.2725 3.50831 10.1338 3.45802 10H11.0692C11.5861 10.0375 12 10.4554 12 10.9839V13H16V10C16 8.89539 15.1046 8 14 8H9.00002V3.28467C9.00002 2.49219 9.57668 2 10.5049 2C11.4273 2 12 2.49219 12 3.28467V3.99268H14V3.28467C14 1.38135 12.5303 0 10.5049 0C8.47414 0 7.00002 1.38135 7.00002 3.28467V8H0V10H0.45801C1.03174 10 1.521 10.3477 1.61621 10.7978L2.83496 17.5845C3.01129 18.4239 3.55823 19.1198 4.29126 19.5468L3.31262 22H5.4657L6.26355 20H17.7365L18.5343 22H20.6874L19.7082 19.5455C20.4423 19.1157 20.991 18.4128 21.1709 17.5557L22.3779 10.8271C22.479 10.3476 22.9683 9.99999 23.542 9.99999H24V7.99999H16.8481V8Z",
    fill: "currentColor"
  }));
}
function BathIconSmall(props) {
  return (0, _core.jsx)(BathIcon, _extends({
    size: "small"
  }, props));
}